import DownloadIcon from '@/common/assets/icons/download.svg?react';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import { DownloadZipsModalType } from '@/modules/FileDetail/components/documentation/modals/DownloadZipsModal.type.ts';
import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { downloadFilePrintedQueryOptions } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadFilePrinted/downloadFilePrintedQueryOptions';
import useToast from '@/common/store/alert/useToast';

export default ({ closeModal, open }: DownloadZipsModalType) => (
  <MainModal open={open} closeModal={closeModal}>
    <DownloadFilePrintedVersionModal />
  </MainModal>
);

const DownloadFilePrintedVersionModal = () => {
  const { id } = useParams();
  const userToken = window.localStorage.getItem('auth-storage');
  const { showAlert } = useToast();

  const { mutate } = useMutation({
    ...downloadFilePrintedQueryOptions(),
    onSuccess: (data) => {
      if (data?.path) {
        window.open(
          `${data.path}&token=${JSON.parse(userToken!).state.token}`,
          '_blank',
        );
      }
    },
    onError: () => {
      showAlert({
        description: 'دانلود مدارک ناموفق بود',
        type: 'error',
      });
    },
  });
  return (
    <>
      <TitleDescription textStyle="h2" color="black-1">
        دانلود
      </TitleDescription>
      <CardButton
        title="دانلود همراه با عکس (با کیفیت بالا)"
        hasArrow={false}
        renderTag={() => (
          <Flex gap="3" alignItems="center">
            <DownloadIcon stroke={token('colors.purple-2')} />
            <Typography textStyle="b2" color="purple-2">
              دانلود
            </Typography>
          </Flex>
        )}
        cardProps={{
          boxShadow: 'none',
          onClick: () => {
            mutate({ id: id!, show_image: true, images_quality: 'high' });
          },
        }}
      />
      <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
      <CardButton
        title="دانلود همراه با عکس (با کیفیت پایین)"
        hasArrow={false}
        renderTag={() => (
          <Flex gap="3" alignItems="center">
            <DownloadIcon stroke={token('colors.purple-2')} />
            <Typography textStyle="b2" color="purple-2">
              دانلود
            </Typography>
          </Flex>
        )}
        cardProps={{
          boxShadow: 'none',
          onClick: () => {
            mutate({ id: id!, show_image: true, images_quality: 'low' });
          },
        }}
      />
      <Box mx="1rem" borderBottom="1px solid {colors.gray-2}" />
      <CardButton
        title="دانلود بدون عکس"
        hasArrow={false}
        renderTag={() => (
          <Flex gap="3" alignItems="center">
            <DownloadIcon stroke={token('colors.purple-2')} />
            <Typography textStyle="b2" color="purple-2">
              دانلود
            </Typography>
          </Flex>
        )}
        cardProps={{
          boxShadow: 'none',
          onClick: () => {
            mutate({ id: id!, show_image: false, images_quality: 'none' });
          },
        }}
      />
    </>
  );
};
